import {
  API_BASE_URL_HTTP_COMMONS_CB,
  API_ROUTES,
  API_ROUTE_PREFIX_COMMONS_CB,
} from "@tm/api-utils";
import axios from "axios";
import { setURLQueryParams } from "../setURLQueryParams";

export const getCommonsHeaderData = async (
  dvid: string = "",
  profile: string = "PERSONAL",
  auth: string = ""
) => {
  const params = {
    region: "in",
    currency: "inr",
    "user-currency": "INR",
    language: "eng",
  };
  const headers = {
    "Content-Type": "application/json",
    authorization: "h4nhc9jcgpAGIjp",
    currency: "inr",
    deviceid: dvid,
    "entity-name": "india",
    language: "eng",
    "mmt-auth": auth,
    org: "MMT",
    os: "desktop",
    pfm: "desktop",
    profile: profile,
    region: "in",
    tid: dvid,
    vid: dvid,
    "visitor-id": dvid,
    "user-country": "IN",
    "user-currency": "INR",
  };

  const urlParams = setURLQueryParams(params);
  const url = `${API_BASE_URL_HTTP_COMMONS_CB}${API_ROUTE_PREFIX_COMMONS_CB}/${
    API_ROUTES.GET_COMMONS_HEADER_DATA
  }${urlParams ? `?${urlParams}` : ""}`;

  try {
    const response = await axios.get(url, {
      headers,
    });

    return response.data;
  } catch (error) {
    console.log("Common Header Server Side Error ------->", error);
    return null;
  }
};
